<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="mb-n4">
        Проектный сервис
      </v-card-title>
      <!-- selectors -->
      <v-form ref="form" lazy-validation v-model="formRules.valid" class="mb-n1">
        <v-card-text>
          <v-row>
            <v-col sm="6" md="4" class="col-12 mt-3">
                <Carusel-Button :getVal="getDate" />
              </v-col>

            <v-col sm="6" md="4" class="col-12">
              <project-selector v-model="projects" />
            </v-col>

            <v-col xs="12" md="4" align="right" class="mt-3">
              <v-btn
                :disabled="report.without_cache === undefined || report.without_cache"
                :title="titleForCache"
                class="mr-1"
                color="success"
                @click="loadReport(true)"
              >
                <v-icon>mdi-reload</v-icon>
              </v-btn>

              <v-btn
                color="success"
                width="130px"
                :disabled="seacrchBtnDisabled"
                @click="loadReport()"
              >Поиск</v-btn>
            </v-col>
          </v-row>
        </v-card-text>

      </v-form>
    </v-card>


    <!-- total statistic card -->
    <v-card class="mb-4 mt-6" v-if="currentProjects.length > 0">
      <v-card-title>
        <h3 class="mr-5">Всего проектов: {{currentProjects.length}}</h3>
        <v-badge
          class="mr-sm-4 my-2 mb-4"
          bordered
          :color="TotalAcceptedCall < 90 ? 'error' : 'success'"
          overlap
        >
          <v-chip
            :color="TotalAcceptedCall < 90 ? 'error' : 'success'"
            label
            outlined
          >выполнение по уровню сервиса</v-chip>
          <template v-slot:badge>
            {{TotalAcceptedCall}}%
            <v-progress-circular
              v-if="isLoad"
              indeterminate
              color="amber"
              :size="14"
              class="ml-2"
            />
          </template>
        </v-badge>
      </v-card-title>
    </v-card>

    <!-- Accordion -->
    <AccordionStatiz
      :items="getResult"
      :fakeItems="currentProjects"
      noProgress
    >
      <template #title="{ item }">
        <h4 style="min-width: 240px;" :title="item.project.name">{{ shrinkName(item.project.name) }}</h4>
        <div>
          <v-badge
            class="my-2 mx-4"
            bordered
            :color="item.project.actual_service_level !== 0
              && item.project.actual_service_level < item.project.accepted_percent_min
              ? 'error' : 'success'"
            overlap
          >
            <template v-slot:badge>
              {{ Math.round(item.project.actual_service_level) }}%
            </template>

            <v-chip
              :color="
                item.project.actual_service_level !== 0
                && item.project.actual_service_level < item.project.accepted_percent_min ? 'error' : 'success'
              "
              label
              outlined
            >сервис за месяц</v-chip>
          </v-badge>
          <v-badge
            class="my-2 mx-4"
            bordered
            :color="item.project.sl_percent >= item.project.accepted_percent_min
              ? 'success'
              : 'error'
            "
            overlap
          >
            <template v-slot:badge>
              {{ Math.round(item.project.sl_percent) }}% / {{ item.project.wait_time_sl }}с
            </template>

            <v-chip
              :color="item.project.sl_percent >= item.project.accepted_percent_min
                ? 'success'
                : 'error'
              "
              label
              outlined
            >SL</v-chip>
          </v-badge>

          <v-badge
            class="my-2 mx-4 ml-13"
            bordered
            color="info"
            overlap
          >
            <template v-slot:badge>
              {{ item.project.count_all }}
            </template>

            <v-chip
              color="info"
              label
              outlined
            >поступившие</v-chip>
          </v-badge>

          <v-badge
            class="my-2 mx-4"
            bordered
            color="info"
            overlap
          >
            <template v-slot:badge>
              {{ item.project.count_accepted }}
            </template>

            <v-chip
              color="info"
              label
              outlined
            >принятые</v-chip>
          </v-badge>


          <v-badge
            class="my-2 mx-4"
            bordered
            color="info"
            overlap
          >
            <template #badge>
              {{ item.stat_on_avg_count_calls.avg_count_calls }}
            </template>

            <v-tooltip bottom max-width="400">
              <template #activator="{ on }">
                <v-chip
                  v-on="on"
                  color="info"
                  label
                  outlined
                >В среднем в день поступает звонков</v-chip>
              </template>
              <p
                v-for="(str, index) of item.stat_on_avg_count_calls.days"
                :key="index"
                class="ma-0"
              >{{ str }}</p>
            </v-tooltip>
          </v-badge>

          <!-- Статистика по договорам -->
          <v-tooltip bottom max-width="400">
            <template #activator="{ on }">
              <v-chip
                v-on="on"
                class="my-2 mx-4"
                color="info"
                label
                outlined
              >Статистика по договорам</v-chip>
            </template>
            <p
              v-for="(str, index) of item.project.contracts_stat"
              :key="index"
              class="ma-0"
            >{{ str }}</p>
          </v-tooltip>

        </div>
      </template>

      <template #body="{item: accItem}">
        <div class="px-2 py-3">
          <!-- Табы -->
          <ul class="nav-tabs" role="navigation">
            <li
              v-for="day in accItem.days"
              class="nav-link"
              :class="getBgColorForDay(day, accItem)"
              :key="day"
              @click="tabDay(day)"
            >
            {{ day }}
            </li>
          </ul>
          <v-divider />

          <!-- Тело -->
          <div class="tab-content px-1 pt-3">
            <div
              v-for="item in accItem.project_days" class="d-none"
              :id="`day-${(Math.random()*10).toString(32).substring(2)}-${item.day}`"
              :class="{'d-block': current_day === item.day}"
              :key="item.day"
              role="tabpanel"
            >
              <div class="row">

                <!-- Таблица -->
                <div class="col-md-7 col-12">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>

                        <tr>
                          <td>Уровень сервиса</td>
                          <td>{{ item.acceptedPercent }}%</td>
                        </tr>
                        <tr>
                          <td>SL</td>
                          <td>{{ item.SLPercent }}% / {{ accItem.project.wait_time_sl }}с</td>
                        </tr>
                        <tr>
                          <td>Пороговый SL</td>
                          <td>{{ accItem.project.threshold_sl }}% / {{ accItem.project.wait_time_sl }}с</td>
                        </tr>
                        <tr>
                          <td>Норма уровня сервиса</td>
                          <td>{{ accItem.project.accepted_percent_min }}%</td>
                        </tr>
                        <tr>
                          <td>Принятые</td>
                          <td>{{ item.countAccepted }}</td>
                        </tr>
                        <tr>
                          <td>Поступившие</td>
                          <td>{{ item.countAll }}</td>
                        </tr>
                        <tr>
                          <td>Среднее время ожидания принятых звонков</td>
                          <td>{{ item.averageWaitingForAcceptedCalls }}с</td>
                        </tr>
                        <tr>
                          <td>Наличие Сбросов</td>
                          <td>{{ item.hasSkippedCalls ? 'Да' : 'Нет' }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </div>

                <!-- Кнопки / Комменты -->
                <div class="col-md-5 col-12">
                  <div class="row my-2 ml-3">

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          :href="getIgnoreLink(accItem)"
                          target="_blank"
                          color="info"
                        ><v-icon>mdi-phone-off</v-icon>
                        </v-btn>
                      </template>
                      <span>Перейти в игноры</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-3"
                          v-bind="attrs"
                          v-on="on"
                          :href="getSkippedLink(accItem)"
                          target="_blank"
                          color="info"
                        ><v-icon>mdi-phone-remove</v-icon>
                        </v-btn>
                      </template>
                      <span>Перейти в пропущенные вызовы</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          class="ml-3"
                          v-bind="attrs"
                          v-on="on"
                          color="info"
                          :disabled="isAfterTomorow"
                          @click="openHoursModal(item, accItem.project.id)"
                        ><v-icon>mdi-chart-bar</v-icon>
                        </v-btn>
                      </template>
                      <span>Почасовой отчёт</span>
                    </v-tooltip>

                  </div>

                  <!-- Отправка коммента -->
                  <div class="row mt-1 ml-3">
                      <v-progress-circular
                        v-if="isFormCommentLoaded === false"
                        indeterminate
                        color="amber"
                        :size="14"
                        class="ml-2"
                      />
                      <form v-else @submit.prevent="submitForm(accItem.project.name, item.day)" class="row">
                        <div class="col-8">
                          <v-text-field
                            label="Комментарий"
                            :value="text"
                            @change="changeText"
                          />
                        </div>
                        <div class="col-4">
                          <v-btn
                            color="success"
                            type="submit"
                          >Добавить</v-btn>
                        </div>
                      </form>
                  </div>

                  <div class="row mt-2 mb-4 ml-3">
                    <v-checkbox
                      :input-value="!!item.is_otn_or_norm_exceedance"
                      :disabled="!!otnFlagLoading[otnFlagKey(accItem.project.name, item.day)]"
                      label="ОТН/превышение нормы"
                      dense
                      hide-details
                      class="mt-0 pt-0"
                      @change="toggleOtnFlag(accItem.project.name, item, $event)"
                    />
                  </div>

                  <!-- Комменты -->
                  <div class="row">
                    <div v-if="item.comments !== undefined" class="col-12">
                      <v-progress-circular
                        v-if="isListCommentLoaded === false"
                        indeterminate
                        color="amber"
                        :size="14"
                        class="ml-2"
                      />
                      <div v-else v-for="(comment, index) in item.comments" :key="index" class="col-12">
                        <span class="pl-1">
                          {{ comment.text }} -
                          <span v-if="comment.user !== null" class="small text-muted">
                            {{ comment.user.first_name }} {{ comment.user.last_name }}
                          </span> -
                          <v-btn
                            icon
                            color="warning"
                            @click="clearComment(comment.id)"
                            title="Удалить коммент"
                          >
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </span>
                        <v-divider class="mt-3" />
                      </div>
                    </div>
                  </div>

                  <!-- Статистика по договорам -->
                  <v-expansion-panels flat :value="0" class="mt-2">
                    <v-expansion-panel>
                      <v-expansion-panel-header>Статистика по договорам</v-expansion-panel-header>

                      <v-expansion-panel-content>
                        <p
                          v-for="(str, index) of item.contracts_stat"
                          :key="index"
                          class="ma-0"
                        >{{ str }}</p>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>

                </div>

              </div>

              <div v-if="item.agentCountInQueues && item.agentCountInQueues.length" class="mt-5" style="max-width: 1200px;">
                <p class="ma-0">Количество операторов в очередях</p>
                <!-- Переключалка -->
                <!-- modeAgentQueuesTable 0|1|2 = total_count|result_count|on_pause_count -->
                <v-btn-toggle
                  v-model="modeAgentQueuesTable"
                  mandatory
                  rounded
                  dense
                >
                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon>mdi-account-group</v-icon>
                      </v-btn>
                    </template>
                    <span>Всего операторов в очереди</span>
                  </v-tooltip>

                  <v-tooltip bottom max-width="300">
                    <template #activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon>mdi-account-group-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Фактическое количество операторов в очереди (за вычетом тех что на паузе)</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template #activator="{ on }">
                      <v-btn v-on="on">
                        <v-icon>mdi-account-clock</v-icon>
                      </v-btn>
                    </template>
                    <span>Операторов на паузе</span>
                  </v-tooltip>
                </v-btn-toggle>

                <!-- Таблица -->
                <v-simple-table dense>
                  <thead>
                    <tr>
                      <th>Очередь</th>
                      <th v-for="num in 24"
                        :key="num"
                      >{{ num - 1 }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="(row, index) of item.agentCountInQueues"
                      :key="index"
                    >
                      <td>{{ row.queue }}</td>
                      <td v-for="(data, index) of row.data"
                        :key="index"
                      >{{ getAgentQueuesCellValue(data) }}</td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </div>

            </div>
          </div>
        </div>
      </template>

      <template #fake_title="{item: projectId}">
        <h4 style="min-width:240px">{{ projectsGetter.find(el => el.id === projectId).name }}</h4>
        <v-progress-circular
          indeterminate
          color="green ml-auto"
          :size="25"
          class="ml-auto"
        />
      </template>
    </AccordionStatiz>

    <!-- Почасовой отчёт модалка -->
    <v-dialog v-model="modalHours">
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Почасовой отчёт</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="modalHours = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>

        <v-card-text>
          <v-tabs
            v-model="chartTab"
            grow
          >
            <v-tab @click="fillApexHour">Почасовая динамика</v-tab>
            <v-tab @click="fillApexSl">SL динамика</v-tab>
            <v-tab @click="loadAgentCount">Операторы в очереди</v-tab>
          </v-tabs>

          <div v-if="[0,1].includes(chartTab)">
            <apexchart
              v-if="chartsLoaded"
              type="bar"
              :height="350"
              :options="chartOptions"
              :series="series"
            />

            <v-sheet
              v-if="chartsLoaded === false"
              height="350"
              class="d-flex align-center justify-center"
            >
              <v-progress-circular
                indeterminate
                color="green"
                size="64"
              />
            </v-sheet>
          </div>

          <div class="mt-4" v-else-if="chartTab === 2">
            <p>
              {{ pickedDateString }}
              <v-tooltip bottom max-width="400">
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="info" size="32" style="cursor: help;">mdi-information-slab-symbol</v-icon>
                </template>

                <p class="mb-0">Первое число - общее кол-во операторов в линии</p>
                <p class="mb-0">Второе число - кол-во операторов за вычитом длительных пауз (от 30 мин)</p>
              </v-tooltip>
            </p>

            <v-data-table
              v-if="agentCountLoading === false"
              dense
              :items="agentCountData.items"
              :headers="agentCountData.headers"
              disable-pagination
              hide-default-footer
            />

            <v-sheet
              v-if="agentCountLoading"
              height="350"
              class="d-flex align-center justify-center"
            >
              <v-progress-circular
                indeterminate
                color="green"
                size="64"
              />
            </v-sheet>
          </div>
        </v-card-text>

      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {requiredRule} from "~/plugins/rules";
import moment from "moment";
import CaruselButton from '~/components/partials/CaruselButton.vue';
import AccordionStatiz from "~/components/partials/AccordionStatiz";
import ProjectSelector from '~/components/partials/selectors/ProjectSelector.vue';

export default {
  components: { CaruselButton, AccordionStatiz, ProjectSelector },
  name: "ProjectService",
  data() {
    return {
      formRules: {
        valid: false,
        required: requiredRule,
      },
      percentRules: [
        v => !v || (v >= 0 && v <= 100) || 'Допускаются только значения от 0 до 100',
      ],
      projectRules: [
        v => v.length === 1 || 'Item is required',
        v => v !== null || 'Item is required',
      ],
      date: null,
      savedDate: null,
      pickedDate: 'current_month',
      period: {},
      projects: [],
      queues: [],
      report: {
        items: [],
        projectInfo: {},
        projectWiretapIsNeeded: false,
        month: 'current_month',
      },
      wiretapping_rate: '',
      accepted_percent: '',
      text: '',
      current_day: 1,
      isLoad: false,
      isFormCommentLoaded: true,
      isListCommentLoaded: true,
      otnFlagLoading: {},
      seacrchBtnDisabled: false,
      currentProjects: [],
      titleForCache: 'Загрузить данные без кеширования. Для ускоренной загрузки звонков, используется кеш, информация в котором обнуляется ежесуточно. Соответственно, если сегодня обновилась информация по звонкам, например были проставлены КЛН, то для получения актуальных данных нужно нажать на эту кнопку. Нажимая на эту кнопку, следует понимать что загрузка информации займёт в разы больше времени чем при обыкновенной загрузке с использованием кеша.',
      stopLoading: false,
      modalHours: false,

      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          background: '#00000000'
        },
        legend: {
          show: false,
        },
        colors: [
          '#4CAF50',
          '#FF9800',
          '#F44336',
        ],
        theme: {
          mode: 'light'
        },
        fill: {
          opacity: 1
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          min: 0,
          max: 100,
          tickAmount: 5
        }
      },
      series: [],

      chartsLoaded: false,
      chartTab: null,
      selectedItem: null,
      selectedProjectId: null,
      preparedChart: null,

      agentCountLoading: false,
      agentCountData: {
        headers: [],
        items: [],
      },
      pickedDateString: '',
      modeAgentQueuesTable: 0,
    }
  },

  computed: {
    ...mapGetters({
      hasPermission: "user/hasPermission",
      projectsGetter: "graphql/allProjects",
      queuesGetter: "projects/queues",
      filteredQueues: "projects/filteredQueues",
      loading: "shared/getLoading",
      meta: "shared/meta",
      getResult: "reports_project_service/getResult",
    }),

    payload() {
      return {
        projects: null,
      }
    },

    wiretappingRateTitle() {
      if (this.report.wiretapping_rate !== '') {
        return 'Целевой показатель количества прослушанных звонков к их общему количеству';
      }

      return 'Целевой показатель количества прослушанных звонков к их общему количеству.\n'
          + 'Если прогнозное количество/количество звонков за месяц:\n'
          + '- до 100 звонков за месяц - 30%\n'
          + '- от 101 до 300 звонков - 15%,\n'
          + '- от 301 до 500 зв. - 10%,\n'
          + '- от 501 до 7500 зв. - 5%,\n'
          + '- от 7501 зв. и более - 3%.\n'
          + '- от 15001 зв. и более - 1.5%';
    },

    callsCountTitle() {
      if (this.report.month === 'last_month') {
        return 'Всего звонков';
      }

      return 'Кол-во принятых звонков за 28 дней на текущую дату. / 28 дней * 30.42 (среднее количество дней в месяце)';
    },

    rabbitIconTitle() {
      return 'Оператор заслуживающий доверия т.к. выполнены все следующие условия:\n'
          + 'а) % прослушки за выбранный  месяц более 3%\n'
          + 'б) кол-во прослушанных звонков за выбранный месяц более 3 шт.\n'
          + 'в) у оператора за последний месяц КЛН выше 97%\n'
          + 'г) у оператора за 3 последних месяца (в том числе текущем) КЛН выше 97%';
    },

    exclamationMarkIconTitle() {
      return 'Оператор требующий внимания:\n'
          + 'а) у оператора средний КЛН <90\n'
          + 'б) норма прослшки по оператору увеличена на 25% пока выполняется первое условие\n'
    },

    TotalAcceptedCall() {
      if (this.getResult.length === 0) return 0;
      let totalPercentDone = 0;

      this.getResult.forEach(el => {
        if (el.project.actual_service_level  >= el.project.accepted_percent_min) totalPercentDone++;
      });

      return Math.round((totalPercentDone / this.getResult.length) * 100);
    },

    isDarkTheme() {
      return this.$vuetify.theme.isDark
    },

    isAfterTomorow() {
      const now = moment()
      const pickedDate = moment(this.savedDate).set('date', this.current_day)
      return moment(pickedDate).isAfter(now)
    },
  },

  watch: {
    modalHours(val) {
      if (val) return
      this.chartTab = 0
      this.preparedChart = null
    },

    isDarkTheme() {
      this.changeApexTheme()
    },
  },

  methods: {
    ...mapActions({
      loadWiretappingRate: 'reports_project_service/loadWiretappingRate',
      loadAgentsInQueues: 'reports_project_service/loadAgentsInQueues',
      setResult: 'reports_project_service/setResult',
      clearResult: 'reports_project_service/clearResult',
      addComment: 'reports_project_service/addComment',
      removeComment: 'reports_project_service/removeComment',
      setDayFlag: 'reports_project_service/setDayFlag',
      resetAllState: 'resetAllState',
    }),

    getDate(data) {
      let month = +moment(data.start).format("MM") - 1
      this.date = moment(data.start).format('YYYY-MM-DD')
      this.period = {
        'start': moment(data.start).format('YYYY-MM-DD HH:mm:ss'),
        'end': moment(data.end).format('YYYY-MM-DD HH:mm:ss')
        }
      this.pickedDate = ((+moment().format("MM") - 1) === month)? 'current_month' : 'last_month';
    },

    getIgnoreLink({ project }) {
      let day = moment(this.date).set('date', this.current_day)
      let periodStart = day.format('Y-M-D 00:00:00')
      let periodEnd = day.format('Y-M-D 23:59:59')
      return `/stat/OperatorsIgnore?project=${project.id}&period[start]=${periodStart}&period[end]=${periodEnd}`
    },

    getSkippedLink({ project }) {
      let day = moment(this.date).set('date', this.current_day)
      let periodStart = day.format('Y-M-D 00:00:00')
      let periodEnd = day.format('Y-M-D 23:59:59')
      return `/stat/speech-analysis/report?project=${project.id}&call_status=ABANDON&period[start]=${periodStart}&period[end]=${periodEnd}`
    },

    tabDay(index) {
      this.current_day = index
    },

    shrinkName(projName) {
      if (projName.length > 17) return projName.match(/^.{17}/)[0] + '...'
      else return projName
    },

    async submitForm(project_name, day) {
      this.isFormCommentLoaded = false

      this.addComment({
        project_name: project_name,
        text: this.text,
        date: this.date.replace(/(\d{2})$/, day.toString().replace(/(^\d{1}$)/, '0$1')),
      }).then(() => {
        this.loadReport();
        this.isFormCommentLoaded = true;
        this.text = '';
      });
    },

    async clearComment(id) {
      this.isListCommentLoaded = false

      this.removeComment({
        id: id,
      }).then(() => {
        this.loadReport();
        this.isListCommentLoaded = true;
      });
    },

    otnFlagKey(projectName, day) {
      return `${projectName}__${day}`
    },

    formatProjectDayDate(day) {
      return this.date.replace(/(\d{2})$/, day.toString().replace(/(^\d{1}$)/, '0$1'))
    },

    async toggleOtnFlag(projectName, item, value) {
      const key = this.otnFlagKey(projectName, item.day)
      const nextValue = !!value
      this.$set(this.otnFlagLoading, key, true)

      try {
        await this.setDayFlag({
          project_name: projectName,
          date: this.formatProjectDayDate(item.day),
          is_otn_or_norm_exceedance: nextValue,
        })
        this.$set(item, 'is_otn_or_norm_exceedance', nextValue)
      } catch (error) {
        // leave previous value; checkbox is bound via :input-value
      } finally {
        this.$set(this.otnFlagLoading, key, false)
      }
    },

    changeText(val) {
      this.text = val;
    },

    openHoursModal(item, projectId) {
      this.selectedItem = item
      this.selectedProjectId = projectId
      this.fillApexHour()
      this.modalHours = true
    },

    fillApexHour() {
      if (this.preparedChart === 'hour') return

      this.chartsLoaded = false
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      // Это извращение чтоб чарты нормально свои опции подхватывали =(((
      let items = this.selectedItem.hourDynamic
      delete options.yaxis.max

      setTimeout(() => {
        this.series = []

        let accepted = []
        let missedLessWaitTime = []
        let missedMoreWaitTime = []

        for (let item of items) {
          accepted.push(Math.floor(item.countAccepted))
          missedLessWaitTime.push(Math.floor(item.countMissedLessWaitTime))
          missedMoreWaitTime.push(Math.floor(item.countMissedMoreWaitTime))
        }

        this.series.push({name: 'Принятые', data: accepted})
        this.series.push({name: 'Пропущенные менее порогового', data: missedLessWaitTime})
        this.series.push({name: 'Пропущенные более порогового', data: missedMoreWaitTime})

        this.chartOptions = Object.assign(this.chartOptions, options)
        this.preparedChart = 'hour'
        this.chartsLoaded = true
      }, 500)
    },

    fillApexSl() {
      if (this.preparedChart === 'sl') return

      this.chartsLoaded = false
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      // Это извращение чтоб чарты нормально свои опции подхватывали =(((
      let items = this.selectedItem.SLByHour
      options.yaxis.max = 100

      setTimeout(() => {
        this.series = []

        let percents = []

        for (let item of items) {
          percents.push(Math.floor(item.SLPercentByHour))
        }

        this.series.push({name: '%', data: percents})

        this.chartOptions = Object.assign(this.chartOptions, options)
        this.preparedChart = 'sl'
        this.chartsLoaded = true
      }, 500)
    },

    changeApexTheme() {
      if (this.isDarkTheme) {
        this.chartOptions.chart.background = '#00000000'
        this.chartOptions.theme.mode = 'dark'
      } else {
        this.chartOptions.chart.background = '#00000000'
        this.chartOptions.theme.mode = 'light'
      }
    },

    getBgColorForDay(day, accItem) {
      let res = ''
      if (this.current_day === day) res = 'active'

      if ('cell_color' in accItem.project_days[day]) {
        res += ' '
        res += `bg-${accItem.project_days[day].cell_color}`
      }

      return res
    },

    getAgentQueuesCellValue(data) {
      if (this.modeAgentQueuesTable === 0) return data.total_count
      else if (this.modeAgentQueuesTable === 1) return data.result_count
      else if (this.modeAgentQueuesTable === 2) return data.on_pause_count
    },

    async loadReport(withoutCache = false) {
      if (this.$refs.form.validate()) {
        this.clearResult()
        this.isLoad = true
        this.seacrchBtnDisabled = true
        let date = this.date
        this.savedDate = date
        this.payload.date = date

        if (withoutCache) this.payload.without_cache = true
        else if (this.payload.without_cache !== undefined) delete this.payload.without_cache

        this.report.month = this.pickedDate

        let projects = this.projects.slice()
        this.currentProjects = this.projects.slice()

        while (projects.length > 0 && !this.stopLoading) {
          this.payload.projects = [projects[0]]

          if (this.wiretapping_rate !== '' && !!+this.wiretapping_rate ) {
            this.payload['wiretapping_rate'] = this.wiretapping_rate
          }

          if (this.accepted_percent !== '') {
            this.payload['accepted_percent'] = this.accepted_percent
          }

          let response = await this.loadWiretappingRate(this.payload)

          this.report.without_cache = response.without_cache
          this.setResult(response)
          projects.shift()
        }
      }
      this.isLoad = false
      this.seacrchBtnDisabled = false
    },

    async loadAgentCount() {
      this.agentCountLoading = true

      const day = moment(this.savedDate).set('date', this.current_day).format('YYYY-MM-DD')
      this.pickedDateString = day

      const payload = {
        project: this.selectedProjectId,
        day,
      }

      const data = await this.loadAgentsInQueues(payload)
      const headers = [{text: '', value: 'queue'}]
      const items = []

      for (const count of data[0].data) {
        headers.push({text: `${count.hour}:00`, value: `hour_${count.hour}`, align: 'center'})
      }

      for (const item of data) {
        const newItem = {queue: item.queue}

        for (const count of item.data) {
          newItem[`hour_${count.hour}`] = count.count
        }

        items.push(newItem)
      }

      this.agentCountData.headers = headers
      this.agentCountData.items = items

      this.agentCountLoading = false
    },

    testLog(...args) {
      console.log(...args)
    },
  },

  mounted() {
    this.clearResult();

    // Заполням xaxis ApexChart
    for (let i = 0; i < 24; i++) {
      let h = i < 10 ? '0' + i : i
      this.chartOptions.xaxis.categories.push(h + ':00')
    }

    this.changeApexTheme()
  },

  beforeDestroy() {
    this.stopLoading = true;
    this.clearResult();
    this.resetAllState();
  },
}
</script>

<style scoped lang="scss">
.nav-tabs {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;

  .nav-link {
    --bgColor: transparent;
    --border-bottom-color: currentColor;

    cursor: pointer;
    width: 30px;
    aspect-ratio: 1;
    display: grid;
    place-items: center;
    background-color: var(--bgColor);
    transition: background-color 50ms;

    &.bg-success {
      --bgColor: #28a745;
    }
    &.bg-danger {
      --bgColor: #f44336;
    }
    &.bg-warning {
      --bgColor: #ff9800;
    }
    &.active:not(.bg-success) {
      --border-bottom-color: #28a745;
      color: #28a745;
    }
    &.active {
      border-bottom: 4px solid;
      border-bottom-color: var(--border-bottom-color);
      font-weight: bold;
    }

    &:hover {
      background-color: color-mix(in srgb, var(--bgColor) 60%, black);
      color: #fafafa;
    }
  }
}
</style>
